var $00beea4d53fc8dba$exports = {};
$00beea4d53fc8dba$exports = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};


export {$00beea4d53fc8dba$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
